import { render } from "./HeroiconsOutlineZoomOut.vue?vue&type=template&id=0b5fb714"
const script = {}

import exportComponent from "/var/www/doughcoteam.co.uk/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineZoomOut.vue"]])

export default __exports__